<template>
  <div>
    <!-- 表格 -->
    <el-table
      v-bind="attrs"
      v-on="$listeners"
      ref="table"
      style="width: 100%"
      v-tloading="loading"
    >
      <el-table-column
        v-if="selection"
        type="selection"
        width="55"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :label="$t(item.label)"
        :prop="item.prop"
        :width="item.width || 'auto'"
        :align="item.align || 'left'">
        <template slot-scope="scope">
          <template v-if="item.type === 'radio'">
            <el-radio
              v-model="radioId"
              :label="scope.row"
              @change="handleRadioSelect(scope.row)" >
                <span></span>
            </el-radio>
          </template>
          <template v-else>
            {{ $t(scope.row[item.prop]) }}
          </template>
        </template>
      </el-table-column>
      <!-- 自定义插槽 -->
      <slot></slot>
      <!-- 数据为空 -->
      <EmptyData
        slot="empty"
        :empty-type="emptyType"
        :empty-text="emptyText"/>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    selection: {
      type: Boolean,
      default: false
    },
    // 定义每一列的属性，参考element-ui中的table-column可定义属性
    columnList: {
      type: Array,
      default () {
        return []
      }
    },
    // 空类型
    emptyType: {
      type: String,
      default: ''
    },
    // 空文本
    emptyText: {
      type: String,
      default: '查询无记录'
    },
    // 数据最多展示几行
    maxRow: {
      type: Number,
      default: 9999
    },
    // 加载中
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // $attrs的新副本
      attrs: {},
      // 单选按钮
      radioId: ''
    }
  },
  watch: {
    maxRow: {
      handler (val) {
        const data = this.$attrs.data && this.$attrs.data.filter((item, index) => index < val)
        this.attrs = Object.assign({}, this.$attrs, {
          // 根据maxRow对数组data做一层筛选
          data
        })
      },
      immediate: true
    },
    // 监听data
    '$attrs.data': {
      handler (val) {
        const data = val && val.filter((item, index) => index < this.maxRow)
        this.attrs = Object.assign({}, this.$attrs, {
          data
        })
      },
      immediate: true
    }
  },
  methods: {
    // 单选按钮事件
    handleRadioSelect (item) {
      this.$emit('radioSelect', item)
    }
  }
}
</script>

<style scoped lang="less">
</style>
